<template>
  <v-list-item :key="item.title" two-line class="pt-0 pb-0" style="flex-wrap: wrap;">
    <template v-slot:default="{ active, toggle }">
      <v-list-item-icon class="videolisticon">
        <v-icon color="success" class="" v-if="item.watched">fa fa-check-circle</v-icon>
        <v-icon color="success" class="" v-else-if="complete">fa fa-check-circle</v-icon>
        <v-icon v-else style="color:#212121;">fa fa-arrow-circle-right</v-icon>
      </v-list-item-icon>
      <v-list-item-icon class="videolisticon ml-10">
        <v-icon>{{ icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content class="ml-8" style="min-width: 132px">
        <v-list-item-title class="v-list-asset-title" v-text="item.title"></v-list-item-title>
        <v-list-item-subtitle class="text--primary" style="white-space:normal;">{{ item.description
          }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action class="list-icon-action" style="margin: 0px auto !important">
        <v-btn v-if="item.asset_type == 'external link'" @click="openDocument(item.external_link, item.id)"
          class="download-btn download-txt">
          <v-img src="/static/external-link-icon.png" style="margin-right:11px;"></v-img>Open Link
        </v-btn>
        <v-btn v-else-if="item.asset_type == 'powerpoint'" :disabled="item.file.data.disabled"
          class="download-btn download-txt" @click="playPpt(item, item.file.data.id)">
          <v-icon small class="pr-2">fa-play</v-icon>View Slide
        </v-btn>
        <v-btn v-else-if="item.asset_type == 'video' && item.watched" color="download-btn download-txt" @click="playVideo(item)">
          <v-icon small class="pr-2">fa-redo</v-icon>Watch Again
        </v-btn>
        <v-btn v-else-if="item.asset_type == 'video' && !item.watched" class="download-btn download-txt" @click="playVideo(item)">
          <v-icon small class="pr-2">fa-play</v-icon>Play
        </v-btn>
        <v-btn v-else-if="item.asset_type == 'document'" @click="openDocument(item.file.data.url, item.file.data.id)"
          class="download-btn download-txt">
          <v-img src="/static/Vector.png" style="margin-right:11px;"></v-img>
          {{ item.file.data.mime_type.includes('pdf') ? 'Open' : 'Download' }}
        </v-btn>
        <v-btn v-else-if="item.asset_type == 'scorm'" class="download-btn download-txt"
          @click="playScorm(item, item.file.data.id)">
          <v-img src="/static/Vector.png" style="margin-right:11px;"></v-img>
          Play
        </v-btn>
      </v-list-item-action>
    </template>
  </v-list-item>
</template>
<script>
import eventAPI from '@/api/event.js';
import courseAPI from '@/api/course.js';
import { EventBus } from '@/event-bus.js';
export default {
  name: 'TrainingMaterialListItem',
  props: {
    item: {
      type: Object,
      default: null,
    },
    course: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      startTime: 0,
      isPlaying: false,
      confirmStart: 'Do you want to carry on where you left off?',
      firstTime: true,
    };
  },
  methods: {
    openDocument(url, id) {
      this.isPlaying = false;
      let file = this.entity;
      file.related_entity_asset_id = id;
      file.event_data = null;
      file.event_type = 7;
      eventAPI.addEvent(file).then(() => {
        //this.updateAssetsViewed(id);
        this.getCourse();
      });
      window.open(url, '_blank');
    },
    getCourse() {
      courseAPI
        .getCourse(this.id, '?include=enrolled,videos,documents,test,links,ppts,scorm')
        .then((response) => {
          this.$store.dispatch(
            'setUserStats',
            response.data.data.enrolled.data
          );
          this.$store.dispatch('setCoursePlayer', response.data.data);
          EventBus.$emit('WATCHED_ASSETS');
        });
    },
    playPpt(item, id) {
      this.$store.dispatch('setCurrentPpt', item).then((then) => {
        this.$store.dispatch('setPlayPpt', true);
        this.isPlaying = false;
        let file = this.entity;
        file.related_entity_asset_id = id;
        file.event_data = null;
        file.event_type = 7;
        eventAPI.addEvent(file).then(() => {
          //this.updateAssetsViewed(id);
          this.getCourse();
        });
        /*if(this.totalVideos==0) {
           this.isPlaying = false;
            let event = this.entity;
            event.related_entity_asset_id = id;
            event.event_data = null;
            event.event_type = 5;
            event.course_completed_without_video='yes'
            eventAPI.addEvent(event).then(() => {
              this.getCourse();
            });
          }*/
      });
    },
    updateAssetsViewed(id) {
      eventAPI.updateAssetsIsViewed(id);
    },
    loadScorm(item) {
      this.$store.dispatch('setCurrentScorm', item);
    },
    playScorm(item, id) {
      this.$store.dispatch('setCurrentScorm', item).then(() => {
        //this.$store.dispatch("setPlayVideo", true);
        this.$store.commit('setPlayScorm', true);
        this.$vuetify.goTo(200);
        this.isPlaying = false;
        let file = this.entity;
        file.related_entity_asset_id = id;
        file.event_data = null;
        file.event_type = 8;
        eventAPI.addEvent(file).then(() => {
          this.getCourse();
        });
      });
    },
    playVideo(item) {
      this.$store.dispatch('setCurrentVideo', item).then(() => {
        this.$store.dispatch('setPlayVideo', true);
        this.$vuetify.goTo(200);
      });
    },
  },
  computed: {
    mimeType() {
      return this.item.file
        ? this.item.file.hasOwnProperty('data')
          ? this.item.file.data.mime_type
          : this.item.file.mime_type
        : 'link';
    },
    playButton() {
      let video = false;
      switch (this.mimeType) {
        case 'video/mp4':
          video = true;
          break;
        case 'link':
          video = 'link';
          break;
        case 'application/vnd.ms-powerpoint':
          video = 'slideshow';
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          video = 'slideshow';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'image/jpeg':
        case 'image/png':
        case 'application/pdf':
        default:
          video = false;
          break;
      }
      return video;
    },
    icon() {
      var icon = '';
      switch (this.mimeType) {
        case 'link':
          icon = 'fa fa-link';
          break;
        case 'video/mp4':
          icon = 'fa fa-video';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          icon = 'fa-file-word';
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          icon = 'fa-file-ppt';
          break;
        case 'application/pdf':
          icon = 'fa-file-pdf';
          break;
        case 'application/x-zip-compressed':
          icon = 'fa-photo-film-music';
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          icon = 'fa-file-spreadsheet';
          break;  
        default:
          icon = 'fa-file';
          break;
      }
      return icon;
    },
    /*course: function() {
      return this.$store.getters.coursePlayer;
    },*/
    // totalVideos: function() {
    //   return this.course.total_videos;
    // },
    entity: function() {
      return {
        related_entity: this.$store.getters.coursePlayer.id,
        entity_lookup_user_id: this.$store.getters.userStats.id,
        entity_type: 1, //course
      };
    },
    complete: function() {
      return this.user.state == 3 || this.user.state == 5 ? true : false;
    },
    user: function() {
      return this.$store.getters.userStats;
    },
    items: function() {
      return this.$store.getters.scorm;
    },
  },
};
</script>
<style>
.list-icon {
  margin: auto !important;
  vertical-align: middle;
}
.v-list {
  padding: 0px 0 !important;
}
</style>
